import { motion } from 'framer-motion';
import LogoImageMini from '../../atoms/Logo/LogoImageMini';

const SplashScreen: React.FC = () => {
  const animation = {
    scale: [1, 2, 2, 1, 1],
    rotate: [0, 0, 360, 360, 0],
  };

  const transition = {
    duration: 2,
    ease: 'easeInOut',
    times: [0, 0.2, 0.5, 0.8, 1],
    repeat: Infinity,
    repeatDelay: 1,
  };

  return (
    <div className="flex h-screen w-screen justify-center items-center bg-white">
      <motion.div animate={animation} transition={transition}>
        <LogoImageMini className="w-20 h-20" isGradient />
      </motion.div>
    </div>
  );
};

export default SplashScreen;
